import axios from 'axios';
import React, { useEffect, useState } from 'react'
import Jammain from './Jammain';
import { ToastContainer, toast } from "react-toastify";
import Bookingvoucher from './Bookingvoucher';


export default function Listvoucher() {
    const urlapi = process.env.REACT_APP_BASE_URL;
    const [voucher, setVoucher] = useState([])
    const kadaluarsa = new Date() >= new Date(2026, 9, 1)

    const getdata = async () => {
        try {
            const response = await axios.get(urlapi + 'Voucher?iduser=' + localStorage.getItem('id'))
            setVoucher(response.data)
        } catch (error) {
            // console.log(error.message);

        }
    }


    useEffect(() => {
        if (!kadaluarsa) {
            getdata();
        }
    }, []);

    return (
        <div>
            <div className="d-flex justify-content-between mb-3">
                <label className='fw-bold' style={{ color: '#2452B' }}>Data voucher anda</label>
                <label style={{ color: '#2452B' }}><i className="fas fa-ticket"></i></label>
            </div>

            {kadaluarsa ?

                <div className="d-flex align-items-center justify-content-center mt-3" style={{ minHeight: '300px' }}>
                    <div className="text-center shadow-lg rounded-4 border-0 w-100" style={{ maxWidth: '420px', background: '#fff' }}>
                        <div className="p-4" style={{ background: 'linear-gradient(135deg, #0f1677, #4e9dd1)', borderRadius: '16px 16px 0 0' }}>
                            <img src="/img/warning.png" alt="warning" className="img-fluid mb-2" style={{ width: '90px', height: '90px', objectFit: 'contain', filter: 'brightness(0) invert(1)' }} />
                            <h5 className="fw-bold text-white mb-0">Voucher Tidak Aktif</h5>
                        </div>
                        <div className="p-4">
                            <p className="mb-0 text-secondary fw-semibold" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
                                <i className="fas fa-exclamation-circle text-danger me-2"></i>
                                Voucher anda tidak bisa digunakan tanggal penggunaan sudah lewat
                            </p>
                        </div>
                    </div>
                </div>

                :

                <>
                    {voucher == false || voucher == '' ?
                        <>
                            <div className='' style={{ height: '500px' }}>
                                <div className='text-center mt-5'>
                                    <img src="img/vc33.webp" className="img-fluid" alt="Responsive image" /> <br />
                                    <small className='fw-bold' style={{ color: '' }}>Untuk saat ini voucher anda belum tersedia, tingkatkan booking anda untuk mendapatkan voucher medan mini soccer</small>
                                </div>

                            </div>
                        </>


                        : <></>}

                    {voucher.map((list, index) => {
                return (
                    <div key={index}>
                        <div className='card mt-2' style={{ borderColor: '#20254B' }}>
                            <div className='card-body'>
                                <div className="d-flex justify-content-between">
                                    <h5 className='fw-bold' style={{ color: '#20254B' }}>
                                        <i className='fas fa-ticket'></i> {index + 1}</h5>
                                    <h5 className='fw-bold' style={{ color: '#20254B' }}>  {list.kode_voucher}</h5>
                                </div>
                                <hr />
                                <div className="d-flex justify-content-between fw-bold">
                                    <small><i className='fas fa-calendar-day'></i> Tanggal diterima : </small>
                                    <small>{list.tgl_terima}</small>

                                </div>
                                <div className="d-flex justify-content-between mt-2 fw-bold">
                                    <small><i className='fas fa-futbol'></i> Lapangan :</small>
                                    <small>Lapangan {list.lapangan}</small>
                                </div>

                                <div className="d-flex justify-content-between mt-2 fw-bold">
                                    <small><i className='fas fa-clock'></i> Waktu :</small>
                                    <small>2 Jam </small>
                                </div>

                                <div className="d-flex justify-content-between mt-2 fw-bold">
                                    <small><i className='fas fa-calendar-day'></i> Hari :</small>
                                    <small>Senin / Selasa</small>
                                </div>
                                <hr />


                                <Jammain kode_voucher={list.kode_voucher} idlap={list.id_lap} lapangan={list.lapangan} />


                                <Bookingvoucher kode_voucher={list.kode_voucher} />
                            </div>
                        </div>
                    </div>
                )
            })}
                </>
            }

            <ToastContainer />
        </div>
    )
}
